/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Support_InfoInputs */



/**
* | output |
* | --- |
* | "Wundo prepares your 1:1s with this colleague automatically. With the notetaker or your own notes, Wundo also writes a report, and the conversation info grows." |
*
* @param {Team_Support_InfoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_support_info = /** @type {((inputs?: Team_Support_InfoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Support_InfoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo bereidt je 1:1's met deze collega automatisch voor. Met de notetaker of je eigen notities maakt Wundo ook een verslag, en groeit de gespreksinfo.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo prépare automatiquement vos one-to-ones avec ce collègue. Avec le notetaker ou vos propres notes, Wundo rédige aussi un compte rendu, et les infos d'entretien s'enrichissent.")
	return /** @type {LocalizedString} */ ("Wundo prepares your 1:1s with this colleague automatically. With the notetaker or your own notes, Wundo also writes a report, and the conversation info grows.")
});